import React, { useState, useEffect, useRef } from 'react';
import './SecurityAndPrivacy.css';
import { TbScanEye, TbFingerprintScan  } from "react-icons/tb";
import { RiSwordFill } from "react-icons/ri";
import { BsGlobe } from "react-icons/bs";
import { IoSearchCircleSharp } from "react-icons/io5";
import { GrShieldSecurity } from "react-icons/gr";
import { MdPrivacyTip } from "react-icons/md";
import { FaHandSpock , FaFlask, FaFilm, FaArrowAltCircleLeft   } from "react-icons/fa";
import { IoPeopleCircle } from "react-icons/io5";
import { collection, query, where, orderBy, onSnapshot, addDoc, serverTimestamp, doc, getDocs, getDoc, setDoc, updateDoc, arrayUnion} from 'firebase/firestore';
import { db, auth } from '../../Firebase_Config/firebase';
import { NavLink } from "react-router-dom";




const toolsData = {
  SecurePrivateAI: {
    title: 'Secure and Private AI – Udacity:',
    content: [
      `
      <p>Learn about privacy-preserving AI technologies like Federated Learning and Differential Privacy.</p>
      `
    ],
    link: 'https://www.udacity.com/course/secure-and-private-ai--ud185',
    buttonText:'Start Learning',
    accentClass: 'card-accent'
  },
  AISecurity: {
    title: 'AI Security Fundamentals – Microsoft Learn:',
    content: [
      `<p>Provides an understanding of AI security concepts, controls, and testing procedures.</p>
      <p>Want to learn more about AI security? This learning path helps you understand the basic concepts of AI security, the types of security controls that apply to AI systems, and the security testing procedures that you can implement in AI systems to increase the security posture of AI environments.</p>
      <p>Prerequisites: Familiarity basic Artificial Intelligence and security concepts</p>
      `
      
    ],
    buttonText:'Start Learning',
    link: 'https://learn.microsoft.com/en-us/training/paths/ai-security-fundamentals/',
    accentClass: 'card-accent alt'
  },
  Video1: {
    title: `AI Data Privacy`,   
    source: '/Videos/AIDataPrivacy.webm',
    accentClass: 'card-accent alt2',
    commentsDoc: 'comments_AIDataPrivacy'
  },
  Video2: {
    title: `Mastering AI Security To Protect Your System`,   
    source: '/Videos/MasteringAISecurity.webm',
    accentClass: 'card-accent alt3',
    commentsDoc: 'comments_MasteringAISecurity'
  },
};


const SecurityAndPrivacy = () => {
    const getUserId = () => {
    const user = auth.currentUser;
    return user.uid;
  };
    const CommentsSection = ({ commentsDoc }) => {
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [userName, setUserName] = useState("");
  
    useEffect(() => {
  
      const fetchSectorNameAndScores = async () => {
              try {
                  const userId = getUserId();
                  console.log('User ID:', userId); // Add this line for debugging     
                  const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
                  const userDocSnapshot = await getDocs(userDocQuery);     
                  if (!userDocSnapshot.empty) {                      
                      const userDocData = userDocSnapshot.docs[0].data();                  
                      const UserName =userDocData.Name ||0;
                      setUserName(UserName)                        
                  } else {
                      console.log('User document not found for user ID:', userId);
                  }                  
                    } catch (error) {
                        console.error('Error fetching document:', error);
                    }
          };      
          fetchSectorNameAndScores();

          const commentsDocRef = doc(db,"comments", commentsDoc);

          const unsubscribe = onSnapshot(commentsDocRef, (docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              setComments(data.messages || []);
            } else {
              // If the document doesn't exist yet, create it
              setDoc(commentsDocRef, { messages: [] });
            }
          });
  
      return () => unsubscribe();
    }, []);
  
    const handlePostComment = async () => {
      const trimmed = comment.trim();
      if (!trimmed) return;
  
      const user = auth.currentUser;
      if (!user) return;
  
      const newComment = {
        text: trimmed,
        author: userName,
        uid: user.uid,
        timestamp: new Date().toISOString(),
      };
  
      const commentsDocRef = doc(db, "comments", commentsDoc);
  
      try {
        await updateDoc(commentsDocRef, {
          messages: arrayUnion(newComment),
        });
        setComment("");
      } catch (error) {
        console.error("Error posting comment:", error);
      }
    };
  
    return (
      <div style={{  margin: "auto" }}>
        <h2>Comments</h2>
        <div>
          <input
                  className="form_input"
                  type="text"
                  id="comment"
                  name="comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add a comment..."
                />
          <button className='full-width-button' onClick={handlePostComment} >
            Comment
          </button>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          {comments
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .map((c, index) => (
              <div
                key={index}
                style={{ borderBottom: "1px solid #ccc", padding: "1rem 0" }}
              >
                <strong>{c.author}</strong>
                <p>{c.text}</p>
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  {new Date(c.timestamp).toLocaleString()}
                </div>
              </div>
            ))}
        </div>
        {/*<textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Leave a comment..."
          style={{ width: "100%", padding: "0.5rem" }}
        />*/}
       
      </div>
    );
  };

    const [selectedTool, setSelectedTool] = useState('SecurePrivateAI');
    const renderCard = () => {
      const tool = toolsData[selectedTool];

      if (selectedTool === 'Video1' || selectedTool === 'Video2') {
      return (
        <div className='Network-card'>
            <div className={tool.accentClass} />
            <div className="Netprofessional-card">
                <div className="card-body">
                <h2 className="card-title">{tool.title}</h2>
                <div className='trainPP'>
                    <video autoPlay controls key={tool.source}>
                    <source src={tool.source} type="video/webm" />
                    </video>
                </div>
                <CommentsSection commentsDoc={tool.commentsDoc} />
                </div>
            </div>
        </div>
      );
    }
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">{tool.title}</h2>
              {tool.content.map((paragraph, idx) => (
                <div dangerouslySetInnerHTML={{ __html: tool.content }} ></div>
              ))}
              <a href={tool.link} target="_blank" rel="noopener noreferrer" className="full-width-button">
                {tool.buttonText}
              </a>
            </div>
          </div>
        </div>
      );
    };



  return (
    <div className='backgroundHelp'>
      <div className="InternetHyContent">
        <div className='bannerBG'>
          <img src="../banner.png" alt="banner2" className='banner-image' />
        </div>
        <h1 className="helptitle bigger">Security and Privacy in AI</h1>
        <div className='BasicGrid'>
          <div className='BasicGrid2'>
            <NavLink to="/Support" >
              <button className="navButtons">
                <div>
                  <FaArrowAltCircleLeft className="helpicons" />
                </div>
                <span>Back</span>
              </button>
            </NavLink>
            <button className="navButtons" onClick={() => setSelectedTool('SecurePrivateAI')}>
              <div>
                <MdPrivacyTip className="helpicons" />
              </div>
              <span>Secure and Private AI</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('AISecurity')}>
              <div>
                <GrShieldSecurity className="helpicons" />
              </div>
              <span>AI Security Fundamentals</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('Video1')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>AI Data Privacy</span>
            </button>
             <button className="navButtons" onClick={() => setSelectedTool('Video2')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>Mastering AI Security</span>
            </button>
          </div>      
        </div>
        <br/>
        <div className="help-hrLine" />
        <br/>
        {renderCard()}   
      </div>
    </div>
  );
};

export default SecurityAndPrivacy;
